import { useNavigate } from 'react-router-dom';
import { NavigationAdapter } from 'nextstepjs';

export default function useWizardNavigationAdapter(): NavigationAdapter {
  const navigate = useNavigate();

  return {
    push: (to: string) => navigate(to),
    getCurrentPath: () => window.location.pathname,
  };
}
